// =============================================================================
// Request & Response Model
// =============================================================================

import { AxiosError } from 'axios';
import { PUT_SET_ACCOUNT_EXPIRY_DATE } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';

export interface PutSetAccountExpiryDateRequest {
  userUuids: string[];
  expiryDate: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: void) => void;
  onError?: (data: AxiosError) => void;
}

export const useSetAccountExpiryDate = ({ onSuccess, onError }: Input) => {
  const putSetAccountExpiryDate = async (payload: PutSetAccountExpiryDateRequest) => {
    await axiosClient.put<undefined>(PUT_SET_ACCOUNT_EXPIRY_DATE, payload);
  };

  return useCustomMutation(putSetAccountExpiryDate, {
    onSuccess,
    onError,
  });
};
